import React from 'react';
import UnitDetail from '../../components/UnitDetail';
import Units from './Units';

const CreateWrapper = (props) => <UnitDetail {...props} actionType="create" />;
const EditWrapper = (props) => <UnitDetail {...props} actionType="edit" />;

const resource = {
  list: Units,
  create: CreateWrapper,
  edit: EditWrapper,
};

export default resource;
